import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

const moduleSelector = '.tabbed-services';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      const servicesNavigationContainer = query.querySelector('.tabbed-services__container');
      const serviceContainer = query.querySelector('.tabbed-services__service');

      const servicesNavigation = document.createElement('div');
      servicesNavigation.classList.add('tabbed-services__navigation');
      servicesNavigationContainer.appendChild(servicesNavigation);

      const servicesMobileNavigation = document.createElement('div');
      servicesMobileNavigation.classList.add('tabbed-services__navigation__mobile');
      const navigationSplide = document.createElement('div');
      navigationSplide.classList.add('splide');
      servicesMobileNavigation.appendChild(navigationSplide);
      const navigationSplideTrack = document.createElement('div');
      navigationSplideTrack.classList.add('splide__track');
      navigationSplide.appendChild(navigationSplideTrack);
      const navigationSplideList = document.createElement('div');
      navigationSplideList.classList.add('splide__list');
      navigationSplideTrack.appendChild(navigationSplideList);

      servicesNavigationContainer.appendChild(servicesMobileNavigation);

      // Create Splide structure for services
      const servicesSplide = document.createElement('div');
      servicesSplide.classList.add('splide');
      const servicesSplideTrack = document.createElement('div');
      servicesSplideTrack.classList.add('splide__track');
      servicesSplide.appendChild(servicesSplideTrack);
      const servicesSplideList = document.createElement('div');
      servicesSplideList.classList.add('splide__list');
      servicesSplideTrack.appendChild(servicesSplideList);

      // Replace the service container content with the splide structure
      serviceContainer.innerHTML = '';
      serviceContainer.appendChild(servicesSplide);

      data.forEach((item) => {
        const {
          background, title, text,
        } = item;
        const buttonText = item.button_text;
        const buttonLink = item.button_link;

        const serviceNavigationItem = document.createElement('button');
        serviceNavigationItem.classList.add('tabbed-services__navigation__item');
        serviceNavigationItem.textContent = title;

        servicesNavigation.appendChild(serviceNavigationItem);

        const serviceNavigationItemMobile = serviceNavigationItem.cloneNode(true);
        serviceNavigationItemMobile.classList.add('splide__slide');
        navigationSplideList.appendChild(serviceNavigationItemMobile);

        // Create service slide
        const serviceSlide = document.createElement('div');
        serviceSlide.classList.add('splide__slide', 'tabbed-services__service__item');
        serviceSlide.innerHTML = /* html */ `
          <img src="${background}" alt="${title}" loading="lazy">
          <div class="tabbed-services__service__content">
            <h3>${title}</h3>
            <p>${text}</p>
            <a href="${buttonLink}" class="btn-custom primary">${buttonText}</a>
          </div>
        `;
        servicesSplideList.appendChild(serviceSlide);
      });

      // Initialize Splide for mobile navigation
      const mobileSplide = new Splide(navigationSplide, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        arrows: true,
        pagination: false,
      });

      // Initialize Splide for services
      const servicesSlideInstance = new Splide(servicesSplide, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        arrows: false,
        pagination: false,
        drag: true,
        autoWidth: false,
      });

      // Mount both Splides
      mobileSplide.mount();
      servicesSlideInstance.mount();

      // Sync mobile navigation splide with services splide
      mobileSplide.on('moved', (newIndex) => {
        servicesSlideInstance.go(newIndex);
      });

      // Add click handlers after Splides are mounted
      servicesNavigation.querySelectorAll('.tabbed-services__navigation__item').forEach((navItem, index) => {
        navItem.addEventListener('click', () => {
          // Remove active class from all navigation items
          servicesNavigation.querySelectorAll('.tabbed-services__navigation__item').forEach((btn) => {
            btn.classList.remove('active');
          });
          navigationSplideList.querySelectorAll('.splide__slide').forEach((btn) => {
            btn.classList.remove('active');
          });

          // Add active class to clicked item and corresponding mobile nav item
          navItem.classList.add('active');
          const mobileNavItem = navigationSplideList.querySelectorAll('.splide__slide')[index];
          if (mobileNavItem) {
            mobileNavItem.classList.add('active');
          }

          // Navigate to the corresponding service slide and sync mobile navigation
          servicesSlideInstance.go(index);
          mobileSplide.go(index);
        });
      });

      navigationSplideList.querySelectorAll('.splide__slide').forEach((mobileNavItem, index) => {
        mobileNavItem.addEventListener('click', () => {
          // Remove active class from all navigation items
          servicesNavigation.querySelectorAll('.tabbed-services__navigation__item').forEach((btn) => {
            btn.classList.remove('active');
          });
          navigationSplideList.querySelectorAll('.splide__slide').forEach((btn) => {
            btn.classList.remove('active');
          });

          // Add active class to clicked mobile item and corresponding desktop nav item
          mobileNavItem.classList.add('active');
          const desktopNavItem = servicesNavigation.querySelectorAll('.tabbed-services__navigation__item')[index];
          if (desktopNavItem) {
            desktopNavItem.classList.add('active');
          }

          // Navigate to the corresponding service slide
          servicesSlideInstance.go(index);
          // Mobile splide will automatically be in sync since we clicked on it
        });
      });

      // Sync navigation when services slide changes (e.g., via swipe)
      servicesSlideInstance.on('moved', (newIndex) => {
        // Remove active class from all navigation items
        servicesNavigation.querySelectorAll('.tabbed-services__navigation__item').forEach((btn) => {
          btn.classList.remove('active');
        });
        navigationSplideList.querySelectorAll('.splide__slide').forEach((btn) => {
          btn.classList.remove('active');
        });

        // Add active class to corresponding navigation items
        const desktopNavItem = servicesNavigation.querySelectorAll('.tabbed-services__navigation__item')[newIndex];
        const mobileNavItem = navigationSplideList.querySelectorAll('.splide__slide')[newIndex];

        if (desktopNavItem) desktopNavItem.classList.add('active');
        if (mobileNavItem) mobileNavItem.classList.add('active');

        // Sync mobile navigation splide to match
        mobileSplide.go(newIndex);
      });

      // Set first navigation items as active by default
      if (data.length > 0) {
        const firstNavItem = servicesNavigation.querySelector('.tabbed-services__navigation__item');
        const firstNavItemMobile = navigationSplideList.querySelector('.splide__slide');

        if (firstNavItem) firstNavItem.classList.add('active');
        if (firstNavItemMobile) firstNavItemMobile.classList.add('active');
      }
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
